import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../../components/formInputs/FieldWrapper';
import FormUpload from '../../../../components/formInputs/FormUpload';
import { deleteIcon } from '../../../../config/variables';

export default function EditVehicleImageItem({
  data,
  add,
  index,
  arrayHelpers
}: {
  data?: any;
  interior?: boolean;
  add?: boolean;
  expanded: number;
  setExpanded: React.Dispatch<React.SetStateAction<number>>;
  index: number;
  arrayHelpers?: any;
}) {
  const { t } = useTranslation();
  const formik = useFormikContext();

  return (
    <div className="model_gallery_color_form">
      <div className="inputs_group">
        <FieldWrapper>
          <FormUpload formik={formik} name={`${add ? 'new_images' : 'images'}[${index}].url`} />
        </FieldWrapper>
        <FieldWrapper title={t(`alt_en`)} inputName={`${add ? 'new_images' : 'images'}[${index}].alt[en]`} inputPlaceholder={t('alt_en')} input customPadding />
        <FieldWrapper title={t('alt_ar')} inputName={`${add ? 'new_images' : 'images'}[${index}].alt[ar]`} inputPlaceholder={t('alt_ar')} input customPadding />
        {add ? (
          <div className="pointer" onClick={() => arrayHelpers.remove(index)}>
            {deleteIcon}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
}
